const advertisingCampaigns = {
  headlines: 'Заголовки',
  headline: 'Заголовок',
  description: 'Опис',
  adsHeadlinesAndDescriptions: 'Заголовки та описи оголошень',
  summary: 'Підсумок',
  targetCpi: 'Цільовий CPI',
  dailyBudget: 'Щоденні бюджет',
  showHeadlines: 'Показувати заголовки',
  countries: 'Країни',
  duration: 'Тривалість',
};

export default advertisingCampaigns;
